<form [formGroup]="form">
  <label translate>dashboard.edit.title</label>
  <input type="text" formControlName="title" class="form-control" />

  <label translate>dashboard.edit.description</label>
  <input type="text" formControlName="description" class="form-control" />

  <label translate>dashboard.edit.JobDashboardComponent.dataConnections</label>
  <p-multiselect
    [options]="dataConnections"
    formControlName="dataConnectionIds"
    optionValue="id"
    appendTo="body"
    [filter]="false"
    [showClear]="true"
    [showToggleAll]="false"
    optionLabel="name"
    styleClass="w-full md:w-80"
  />

  <label translate>dashboard.edit.JobDashboardComponent.range</label>
  <p-select
    formControlName="range"
    [options]="rangeOptions"
    optionLabel="key"
    optionValue="value"
    appendTo="body"
    class="w-100"
  >
    <ng-template let-selectedOption pTemplate="selectedItem">
      {{ 'dashboard.edit.JobDashboardComponent.rangeOptions.' + selectedOption.key | translate }}
    </ng-template>
    <ng-template let-option pTemplate="item">{{ 'dashboard.edit.JobDashboardComponent.rangeOptions.' + option.key | translate }}</ng-template>
  </p-select>
</form>

@if (form.get('range')!.value === customRange) {
  <label translate>dashboard.edit.JobDashboardComponent.rangeOptions.CUSTOM</label>
  <input required class="form-control" #drp="bsDaterangepicker" bsDaterangepicker [(ngModel)]="dateRange" skipValidation (bsValueChange)="customRangeChange($event)"
  [bsConfig]="{ rangeInputFormat : 'DD.MM.YYYY', containerClass: 'theme-default', displayMonths: 1 }">
}
